import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import toast from "react-hot-toast";

import { AuthContext } from "../App";

function Odjava(props) {
  const { signOut } = useContext(AuthContext);
  toast.success("Uspješno ste se odjavili.", {
    autoClose: true,
    autoClose: 3000
  });
  signOut();
  return null;
  // return <Navigate to="/" />;
}

export default Odjava;
